export default {"src":"/_next/static/media/truck.209d9302.svg","height":50,"width":50};